module.exports = __webpack_public_path__ + "img/狐狸.f8bc273c.gif";